import { useQuery } from 'react-query';

import { authorizedGet } from '../authorizedApi';

// TODO implement caching for pre-signed URLs?

export const useFetchAsset = (assetid: string | undefined) => {
  const { isLoading, data, isError, error, refetch } = useQuery<any, Error>(
    `asset-${assetid}`,
    async () => {
      if (assetid === undefined || assetid === '' || assetid === 'undefined') {
        return undefined;
      }
      const assetURL: RequestInfo = `/asset/${assetid}`;
      const getAsset = await authorizedGet(assetURL);
      const response = await getAsset();
      const data = await response.json();

      return data;
    },
    {
      retry: false,
    }
  );

  return {
    isLoading,
    isError,
    error,
    asset: data,
    refetch,
  };
};
